if (!customElements.get('ly-main-product-form-custom-sidewall-quantity-input')) {
    customElements.define('ly-main-product-form-custom-sidewall-quantity-input', class extends HTMLElement {
        connectedCallback() {
            this.input = this.querySelector('input')
            this.buttons = this.querySelectorAll('button')

            this.input.addEventListener('change', this.inputChangeHandler)
            this.buttons.forEach(button => {
                button.addEventListener('click', this.buttonClickHandler)
            })
        }

        disconnectedCallback() {
            this.input.removeEventListener('change', this.inputChangeHandler)
            this.buttons.forEach(button => {
                button.removeEventListener('click', this.buttonClickHandler)
            })
        }

        inputChangeHandler = () => {
            if (+this.input.value < +this.input.min) {
                this.input.value = this.input.min
            }
        }

        buttonClickHandler = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            switch (evt.currentTarget.name) {
                case 'minus':
                    this.input.stepDown()
                    break
                case 'plus':
                    this.input.stepUp()
                    break
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-sidewall-sidewall-option')) {
    customElements.define('ly-main-product-form-custom-sidewall-sidewall-option', class extends HTMLElement {
        connectedCallback() {
            this.checkbox = this.querySelector('input[type=checkbox]')
            this.wrappers = [...this.querySelectorAll('.ly-main-product-form-custom-sidewall-sidewall-option-side-wrapper')]
        }

        verifyRequired = (input) => {
            input.classList.remove('is-dangerous')
            if (!input.value.trim()) {
                input.classList.add('is-dangerous')
                input.focus()
                throw new Error('Must fill out the required fields')
            }
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: []
            }

            this.wrappers.forEach(wrapper => {
                result.values.push(this.buildOption(wrapper))
            })

            return result
        }

        buildOption = (wrapper) => {
            const key = wrapper.querySelector('.ly-main-product-form-custom-sidewall-sidewall-option-side').textContent

            const input = wrapper.querySelector('input[type=number]')
            this.verifyRequired(input)

            const value = input.value

            return `${key.trim()} : ${value}`
        }

        get checked() {
            return this.checkbox.checked
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-sidewall-sidewall-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-sidewall-sidewall-option-wrapper', class extends HTMLElement {
        connectedCallback() {
            this.sidewallOptions = [...this.querySelectorAll('ly-main-product-form-custom-sidewall-sidewall-option')]
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: []
            }
            const checkedOptions = this.sidewallOptions.filter(option => option.checked)
            if (checkedOptions.length <= 0) {
                throw new Error('Must select at least one sidewall option')
            }

            checkedOptions.forEach(option => {
                result.values.push(option.getOptionData())
            })

            return result
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-sidewall-installation-location-image-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-sidewall-installation-location-image-option-wrapper', class extends HTMLElement {
        connectedCallback() {
            this.imgUploadWrapper = this.querySelector('.upload-wrapper')
            this.imgPreviewWrapper = this.querySelector('.preview-wrapper')
            this.fileInput = this.querySelector('input[type="file"]')

            this.fileInput.addEventListener('change', this.previewImage)
            this.imgPreviewWrapper.addEventListener('click', this.removeImage)
        }

        disconnectedCallback() {
            this.fileInput.removeEventListener('change', this.previewImage)
            this.imgPreviewWrapper.removeEventListener('click', this.removeImage)
        }

        previewImage = evt => {
            evt.preventDefault()
            evt.stopPropagation()

            const input = evt.target
            if (!input.files || input.files.length === 0) return

            const file = input.files[0]

            // 只处理图片
            if (!file.type.startsWith('image/')) {
                console.error('只能上传图片文件')
                input.value = ''
                return
            }

            // 生成 Blob URL
            const blobUrl = URL.createObjectURL(file)

            // 获取 img 元素并设置 src
            const img = this.imgPreviewWrapper.querySelector('img')
            if (img) {
                img.src = blobUrl
            }

            // 显示预览区
            this.imgPreviewWrapper.classList.remove('ly-hide')
            // 隐藏上传区
            this.imgUploadWrapper.classList.add('ly-hide')
        }

        removeImage = evt => {
            evt.preventDefault()
            evt.stopPropagation()

            // 清空 input
            this.fileInput.value = ''

            // 清空预览图
            const img = this.imgPreviewWrapper.querySelector('img')
            if (img) {
                img.src = ''
            }

            // 隐藏预览区，显示上传区
            this.imgPreviewWrapper.classList.add('ly-hide')
            this.imgUploadWrapper.classList.remove('ly-hide')
        }

        getOptionData = async () => {
            const result = {
                key: this.fileInput.name,
                values: []
            }
            if (!(this.fileInput.files && this.fileInput.files.length > 0)) return result

            const file = this.fileInput.files[0]
            try {
                if (!globalThis.API?.uploadFiles) throw new Error('文件上传服务不可用')
                const [uploaded] = await globalThis.API.uploadFiles(file)
                if (!uploaded?.url) throw new Error('文件上传结果缺少地址')
                result.values.push(uploaded.url)
            } catch (err) {
                console.error(err)
            }

            return result
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-sidewall-message-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-sidewall-message-option-wrapper', class extends HTMLElement {
        connectedCallback() {
            this.textarea = this.querySelector('textarea')
        }

        getOptionData = () => {
            return {
                key: this.textarea.name,
                values: [this.textarea.value]
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-sidewall')) {
    customElements.define('ly-main-product-form-custom-sidewall', class extends HTMLElement {
        connectedCallback() {
            this.sidewallWrapper = this.querySelector('ly-main-product-form-custom-sidewall-sidewall-option-wrapper')
            this.locationWrapper = this.querySelector('ly-main-product-form-custom-sidewall-installation-location-image-option-wrapper')
            this.messageWrapper = this.querySelector('ly-main-product-form-custom-sidewall-message-option-wrapper')
        }

        buildProperties = async () => {
            const result = [
                { ...this.sidewallWrapper.getOptionData() },
                { ...(await this.locationWrapper.getOptionData()) },
                { ...this.messageWrapper.getOptionData() }
            ]

            return result
        }
    })
}
